import i18nConfig from "@/i18nConfig";
import { useParams } from "next/navigation";

export default function useLocale() {
    const { locale } = useParams();
    const localeParam: string | undefined = Array.isArray(locale)
        ? locale.at(0)
        : locale;
    const localeValue: string = localeParam ?? i18nConfig.defaultLocale;
    return localeValue;
}
